module.exports = __webpack_public_path__ + "static/media/MD - sample example_4.15c27b0e.jpg";